import React from 'react';
import LayoutDashboard from 'app/private/layout';
import { useRouter } from 'hooks/use-router';
import { Route, Switch } from 'react-router-dom';
import AdminList from './pages/admin-list/admin-list';
import AdminPermissionManagement from './pages/admin-permission-management/admin-permission-management';
import { EUsersRoutes } from './index.type';

const Admins = () => {
    const { match } = useRouter();

    return (
        <LayoutDashboard>
            <Switch>
                <Route exact path={match.path}>
                    <AdminList />
                </Route>
                <Route
                    path={`${match.path}/${EUsersRoutes.PermissionManagement}`}
                >
                    <AdminPermissionManagement />
                </Route>
            </Switch>
        </LayoutDashboard>
    );
};

export default Admins;
